import "./carteraAdmin.css";
import NavbarAdminMex from "../components/navbar";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, message, Table } from "antd";
import sampleFile from "./confirmacion_de_pago.xlsx";
import secondSampleFile from "./revalorizacion.xlsx";
import { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const CarteraAdmin = () => {
  const [filePagos, setFilePagos] = useState(null);
  const [uploadingPagos, setUploadingPagos] = useState(false);

  const [fileReval, setFileReval] = useState(null);
  const [uploadingReval, setUploadingReval] = useState(false);

  const [transports, setTransports] = useState([])

  useEffect(() => {
    getTransports();
  },[])


  //fetch to get the transports 
  const getTransports = async() => {
    try {
      const response = await axios.get("https://api.99envios.app/api/cuentas-pagos/transportadoras");
      if(response.data.success === "true") {
        setTransports(response.data.configuraciones)
      }
    } catch(error) {
      message.error("Error to get transports")
      console.error(error)
    }
  }

  const columns = [
    {
    title: "ID Transportadora",
    dataIndex: "id_transportadora",
    key: "id_transportadora",
  },
  {
    title: "Valor Total Entregado",
    dataIndex: "valor_total_entregado",
    key: "valor_total_entregado",
    render: (text) => `$${Number(text).toLocaleString("es-CO")}`,
  },
  {
    title: "Valor Total Deuda",
    dataIndex: "valor_total_deuda",
    key: "valor_total_deuda",
    render: (text) => `$${Number(text).toLocaleString("es-CO")}`,
  },
  ]
  //logic to respond with excel file
  const generarYDescargarExcel = (data) => {
    const workbook = XLSX.utils.book_new();

    const grupos = [
      { key: "grupo_ya_revalorizado", nombre: "Ya Revalorizado" },
      { key: "grupo_valor_inferior", nombre: "Valor Inferior" },
      { key: "grupo_no_encontrado", nombre: "No Encontrado" },
      { key: "grupo_fallidos", nombre: "Fallidos" },
    ];

    let hayDatos = false;

    grupos.forEach((grupo) => {
      const contenido = data[grupo.key];
      if (Array.isArray(contenido) && contenido.length > 0) {
        const sheet = XLSX.utils.json_to_sheet(contenido);
        XLSX.utils.book_append_sheet(workbook, sheet, grupo.nombre);
        hayDatos = true;
      }
    });

    if (hayDatos) {
      const fecha = new Date().toISOString().split("T")[0];
      XLSX.writeFile(workbook, `reporte_revalorizaciones_${fecha}.xlsx`);
    } else {
      message.info("No hay datos para descargar en el reporte.");
    }
  };
   //logic to respond with excel file PAGOS
  const generarYDescargarExcelPagos = (data) => {
    const workbook = XLSX.utils.book_new();

    const grupos = [
      { key: "grupos_valor_faltante", nombre: "Valor Faltante" },
      { key: "grupos_valor_excedido", nombre: "Valor Excedido" },
      { key: "grupos_no_encontrados", nombre: "No Encontrado" },
      { key: "grupos_no_entregados", nombre: "No Entregados" },
    ];

    let hayDatos = false;

    grupos.forEach((grupo) => {
      const contenido = data[grupo.key];
      if (Array.isArray(contenido) && contenido.length > 0) {
        const sheet = XLSX.utils.json_to_sheet(contenido);
        XLSX.utils.book_append_sheet(workbook, sheet, grupo.nombre);
        hayDatos = true;
      }
    });

    if (hayDatos) {
      const fecha = new Date().toISOString().split("T")[0];
      XLSX.writeFile(workbook, `reporte_pagos_${fecha}.xlsx`);
    } else {
      message.info("No hay datos para descargar en el reporte.");
    }
  };

  // Pagos
  const handleChangePagos = ({ file }) => {
    setFilePagos(file);
  };

  const handleUploadPagos = async () => {
    if (!filePagos) {
      message.error("Primero debes seleccionar un archivo de pagos.");
      return;
    }

    const formData = new FormData();
    formData.append("archivo", filePagos);
    setUploadingPagos(true);

    try {
      const response = await axios.post(
        "https://99envios.app/api/confirmacion-pago/excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const data = response.data;
      if (response.success !== "true") {
        message.success("Archivo de pagos subido correctamente.");
        generarYDescargarExcelPagos(data)
        setFilePagos(null);
      }
    } catch (error) {
      message.error("Error al subir el archivo de pagos.");
      setFilePagos(null);
    } finally {
      setUploadingPagos(false);
    }
  };

  //revalorización
  const handleChangeReval = ({ file }) => {
    setFileReval(file);
  };

  const handleUploadReval = async () => {
    if (!fileReval) {
      message.error("Primero debes seleccionar un archivo de revalorización.");
      return;
    }

    const formData = new FormData();
    formData.append("archivo", fileReval);
    setUploadingReval(true);

    try {
      const response = await axios.post(
        "https://99envios.app/api/valor-adicional-preenvio/excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const data = response.data;
      if (data.success !== "true") {
        message.success("Archivo de revalorizaciones subido correctamente.");
        generarYDescargarExcel(data);
        setFileReval(null);
      }
    } catch (error) {
      message.error("Error al subir el archivo de revalorizaciones.");
      console.error("Error REVAL:", error);
      setFileReval(null);
    } finally {
      setUploadingReval(false);
    }
  };

  return (
    <>
      <NavbarAdminMex title={"Cartera"} />
      <div className="main-container-cartera-admin">
        {/* PAGOS */}
        <div className="child-container-cartera-admin">
          <div className="title-container-cartera-admin">
            <h1>Pagos</h1>
          </div>
          <div>
            <a href={sampleFile} download>
              <button className="button-masivo-guias-99 button-template-masivo-guias-99">
                <UploadOutlined /> Plantilla
              </button>
            </a>
          </div>
          <div className="button-container-cartera-admin">
            <Upload
              beforeUpload={() => false}
              onChange={handleChangePagos}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>Subir archivo</Button>
            </Upload>

            <Button
              type="primary"
              loading={uploadingPagos}
              disabled={!filePagos || uploadingPagos}
              onClick={handleUploadPagos}
              className="ant-btn-cartera-admin"
            >
              Enviar
            </Button>
          </div>
        </div>

        {/* REVALORIZACIONES */}
        <div className="child-container-cartera-admin">
          <h1>Revalorizaciones</h1>
          <div>
            <a href={secondSampleFile} download>
              <button className="button-masivo-guias-99 button-template-masivo-guias-99">
                <UploadOutlined /> Plantilla
              </button>
            </a>
          </div>
          <div className="button-container-cartera-admin">
            <Upload
              beforeUpload={() => false}
              onChange={handleChangeReval}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>Subir archivo</Button>
            </Upload>

            <Button
              type="primary"
              loading={uploadingReval}
              disabled={!fileReval || uploadingReval}
              onClick={handleUploadReval}
              className="ant-btn-cartera-admin"
            >
              Enviar
            </Button>
          </div>
        </div>
        <Table
        columns={columns}
        dataSource={transports}
        rowKey="id_transportadora"
      />
      </div>
    </>
  );
};

export default CarteraAdmin;
